import { useEffect, useRef } from 'react';

export function useVisibilityAwarePolling(
  callback: () => void,
  intervalMs: number,
  jitterMs: number = 0
): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout> | null = null;

    function schedule() {
      const jitter = jitterMs > 0 ? Math.random() * jitterMs : 0;
      timerId = setTimeout(() => {
        if (document.visibilityState !== 'hidden') {
          callbackRef.current();
        }
        schedule();
      }, intervalMs + jitter);
    }

    function onVisibilityChange() {
      if (document.visibilityState !== 'hidden' && timerId == null) {
        schedule();
      }
    }

    if (document.visibilityState !== 'hidden') {
      schedule();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (timerId != null) {
        clearTimeout(timerId);
        timerId = null;
      }
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [intervalMs, jitterMs]);
}
